import { OnInit } from '@angular/core';
import { Location, PlatformLocation } from '@angular/common';
import { Component, NgZone, ViewContainerRef } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { GoogleAnalyticsEventsService } from './sharedcomponents/commonservice/googleAnalytics/google-analytics-events-service.service';
import { utilityService } from './sharedcomponents/commonservice/utility.service';
import { ErrorPopupComponent } from './sharedcomponents/_directive/error-popup/error-popup.component';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { userlogoutservice } from './sharedcomponents/commonservice/logout/userlogout.service';
import { AlertPopupComponent } from './sharedcomponents/_directive/alert-popup/alert-popup.component';
import { AppSettings } from './sharedcomponents/_common/constants/app.constants';
import { geolocation } from './sharedcomponents/commonservice/geolocation/geoloc';
import { UserGioLocation } from './models/user/usergioLocation';
// import { VersionCheckService } from './_services/version-check.service';
import { environment } from 'environments/environment.prod';

declare var urlParam: any;
declare var ___MobileAgent___: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [Modal, userlogoutservice],
  host: { 'window:beforeunload': 'doSomething' }
})
export class AppComponent implements OnInit {
  languageList;
  isPopupOpen = false;
  isLoginPage = false;
  isSplashscreen = false;
  idleState = 'Not started.';
  timedOut = false;
  TimeoutTimeInSec = 1;
  lastPing?: Date = null;
  cultureName: string

  constructor(
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private http: Http,
    public utilityServ: utilityService,
    public location: PlatformLocation,
    public platformLocation: PlatformLocation,
    private router: Router,
    protected zone: NgZone,
    public modal: Modal,
    public vcref: ViewContainerRef,
    private idle: Idle,
    private keepalive: Keepalive,
    private _logoutserv: userlogoutservice,
    public geoloc: geolocation ,
  ) {

    // let userGioLocation = new UserGioLocation();
    // this.utilityServ.busy = this.geoloc.getGioLocation().subscribe(data => {
    //   this.geoloc.setserGioLocation(userGioLocation)
    // });


    // (<any>window).firebase.analytics().logEvent('notification_received',{
    //   content_type: 'sendmoney',
    //   content_id: 'P12453',
    //   items: [{ name: 'Kittens' }]
    // });
    let baseURL = window.location.origin; // .origin will return protocol, hostname and port number of a URL
    // if (baseURL.indexOf('intercambioexpress.com') > 0) {
    // if (baseURL.toLowerCase()=='intercambioexpress.com' || baseURL.toLowerCase()=='http://intercambioexpress.com' || baseURL.toLowerCase()=='https://intercambioexpress.com') {
    //  window.location.href='https://www.intercambioexpress.com';
    //   return ;
    // }
    const self = this;

    self.cultureName = urlParam("nn");

    if (self.cultureName) {
      sessionStorage.langCode = self.cultureName;
    }

    if (sessionStorage.langCode == undefined) {
      sessionStorage.langCode = 'en';
    }

    translate.use(sessionStorage.langCode);
    // window.onbeforeunload = function(e) {
    //   event.preventDefault();
    //   self.errorPopup(translate.instant('Common_lblOops'), translate.instant('somethingWentWrong_Message'));
    //   //router.navigate(['/login']);
    // };
    // window.onunload = function(e) {
    //   event.preventDefault();
    //   router.navigate(['/login']);
    // };

    this.setBodyClass();
    this.zone.onError.subscribe((e: any) => {
      sessionStorage.removeItem('KeyUID');
      sessionStorage.removeItem('T1');
      sessionStorage.removeItem('T2');
      this.openErrorPopup(e);
    });

    // Google Analytics Service Call

    // bharat
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     (<any>window).ga('set', 'page', event.urlAfterRedirects);
    //     (<any>window).ga('send', 'pageview');
    //   }
    // });

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(AppSettings.IdleTimeInSec);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(this.TimeoutTimeInSec);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleEnd.subscribe(() => (this.idleState = 'No longer idle.'));
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.logOutService();
    });
    idle.onIdleStart.subscribe(event => {
      this.idleState = "You've gone idle!";
      // this.OpenIdleTimePopup();
    });
    // idle.onIdleStart.subscribe(() => (this.idleState = "You've gone idle!"));

    idle.onTimeoutWarning.subscribe(countdown => (this.idleState = 'You will time out in ' + countdown + ' seconds!'));

    // sets the ping interval to 15 seconds
    keepalive.interval(15);
    keepalive.onPing.subscribe(event => {
      this.lastPing = new Date();
    });
    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    // this.reset();
  }

  ngOnInit() {
    // this.versionCheckService.initVersionCheck(environment.versionCheckURL);    
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  setBodyClass() {
    const activePath = this.router.url.split('/')[1];
    let unsub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const _event: any = event;
        let path = _event.url == undefined ? _event.route.path : _event.url;
        path = path.replace('/', '');

        if (path == 'splashscreen' || path == '' || path == 'login' || path == 'register') {
           this.idle.stop();
        } else {
          this.reset();
        }
        this.isLoginPage = false;
        this.isSplashscreen = false;
        if (path == 'splashscreen') {
          this.isSplashscreen = true;
          document.getElementById('_body').classList.remove('bodyBackGroundImage');
          const style = document.createElement('style');
          style.type = 'text/css';
          style.innerHTML = `.bodyBackGroundImage { background: url('../assemoduts/images/login_bg.jpg'); width: 100%; height: auto; background-size: cover;}`;
          document.getElementsByTagName('head')[0].appendChild(style);
          document.getElementById('_body').classList.add('bodyBackGroundImage');
        } else if (path == 'login' || path == '') {
          this.isLoginPage = true;
          document.getElementById('_body').classList.remove('bodyBackGroundImage');
          const style = document.createElement('style');
          style.type = 'text/css';
          if (sessionStorage.loginBGImage == '' || sessionStorage.loginBGImage == undefined) {

            if (___MobileAgent___.IsWrapper()) {
              style.innerHTML = `.bodyBackGroundImage { background: url('../assets/images/login_bg_w.jpg');background-size: cover !important; background-position: center; background-repeat: no-repeat!important;}`;
            } else {
              style.innerHTML = `.bodyBackGroundImage { background: url('../assets/images/login_bg.jpg');background-size: cover !important; background-position: center; background-repeat: no-repeat!important;}`;
            }
          } else {
            style.innerHTML = `.bodyBackGroundImage { background:url(${sessionStorage.loginBGImage});background-size: cover !important; }`;
          }

          document.getElementsByTagName('head')[0].appendChild(style);
          document.getElementById('_body').classList.add('bodyBackGroundImage');
        } else {
          document.getElementById('_body').classList.remove('bodyBackGroundImage');
        }
        if (path == 'splashscreen' || path == '') {
          this.isSplashscreen = true;
        }
      }
    });
  }
  errorPopup(title, message) {
    let modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  openErrorPopup(e: any) {
    this.modal.overlay.defaultViewContainer = this.vcref;
    const _self = this;
    this.translate.use(sessionStorage.langCode).subscribe(data => {
      if (_self.isPopupOpen == false) {
        _self.isPopupOpen = true;
        const modalData: any = {};
        const self = this;
        modalData.Action = self.translate.instant('Common_lblOk');
        modalData.Title = self.translate.instant('Common_lblOops').toString();
        modalData.Message = self.translate.instant('Message_errorMessage').toString();
        return self.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(error => {
            if (modalData.next == 'yes') {
              self.router.navigate(['/login']);
              // this.router.navigateByUrl('/login');
            } else {
            }
          });
        });
      }
    });
  }
  isObj(val) {
    return typeof val === 'object';
  }

  // OpenIdleTimePopup() {
  //   const _self = this;
  //   let modalData: any = {};
  //   modalData.Title = this.translate.instant('Session Expiring!').toString();
  //   modalData.Message = this.translate.instant('Your session is about to expire. Do you need more time?').toString();
  //   //  this.modal.overlay.defaultViewContainer = this.vcRef;
  //   return this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
  //     obj.onDestroy.subscribe(data => {
  //       if (modalData.next == 'yes') {
  //         _self.reset();
  //       } else {
  //         _self.logOutService();
  //       }
  //     });
  //   });
  // }
  logOutService() {
    const _self = this;
    this.utilityServ.busy = this._logoutserv.logout().subscribe(data => {
      let resJSON = data;
      if (resJSON.Envelope.Body.BaseResponse.StatusCode == 10000) {
        sessionStorage.removeItem('KeyUID');
        sessionStorage.removeItem('T1');
        sessionStorage.removeItem('T2');
        let modalData: any = {};
        modalData.Action = this.translate.instant('Common_lblOk');
        modalData.Title = this.translate.instant('Common_lblInfo');
        modalData.Message = this.translate.instant('SessionExpirePopup_desc');
        this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            _self.router.navigate(['/login']);
          });
        });
        return;
      } else if (resJSON.Envelope.Body.BaseResponse.StatusCode == 20001) {
        return false;
      } else {
        // let modalData: any = {};
        // modalData.Title = this.translate.instant('Common_lblOops');
        // modalData.Message = this.translate.instant('Message_errorMessage');
        // this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts